module.exports = __webpack_public_path__ + "img/banner_main1.216866fa.jpg";